const mapsArray = document.querySelectorAll(".google-map");
const initMapScript = () => {
    if (mapsArray && mapsArray.length > 0) {
        const APIKEY = document.querySelector("[data-api-key]").getAttribute("data-api-key");
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://maps.googleapis.com/maps/api/js?key=${APIKEY}&callback=initMap&libraries=&v=weekly`;
        document.head.appendChild(script);
    }
};
const initMap = () => {
    mapsArray && mapsArray.length > 0 && mapsArray.forEach((singleMap) => {
        const markerLat = parseFloat(singleMap.getAttribute("data-lat").replace(",", "."));
        const markerLng = parseFloat(singleMap.getAttribute("data-lng").replace(",", "."));
        const markerTitle = singleMap.getAttribute("data-marker-title");
        const markerDescription = singleMap.getAttribute("data-marker-description");
        if (markerLat && markerLng) {
            const map = new google.maps.Map(singleMap, {
                zoom: 10,
                center: { lat: markerLat, lng: markerLng }
            });
            if (markerTitle && markerDescription) {
                new google.maps.Marker({
                    position: { lat: markerLat, lng: markerLng },
                    map: map,
                    title: markerTitle,
                    label: markerDescription
                });
            }
        }
    });
};
//USARE PER DUE MARKER
/**
 * Come dovrebbero arrivarmi i dati?
 * Crea un mockup
 * */
//const mapsArray = document.querySelectorAll(".google-map");
//const initMapScript = () => {
//    if (mapsArray && mapsArray.length > 0) {
//        const APIKEY = "AIzaSyD03t8qazgdw-SdqcNnlH124LtF4NpLkes";
//        const script = document.createElement('script');
//        script.async = true;
//        script.src = `https://maps.googleapis.com/maps/api/js?key=${APIKEY}&callback=initMap&libraries=&v=weekly`;
//        document.head.appendChild(script);
//    }
//};
//const initMap = () => {
//    mapsArray && mapsArray.length > 0 && mapsArray.forEach((singleMap) => {
//        //styling map
//        const styleMap = [
//            {
//                "featureType": "landscape",
//                "stylers": [
//                    {
//                        "hue": "#FFBB00"
//                    },
//                    {
//                        "saturation": 43.400000000000006
//                    },
//                    {
//                        "lightness": 37.599999999999994
//                    },
//                    {
//                        "gamma": 1
//                    }
//                ]
//            },
//            {
//                "featureType": "road.highway",
//                "stylers": [
//                    {
//                        "hue": "#FFC200"
//                    },
//                    {
//                        "saturation": -61.8
//                    },
//                    {
//                        "lightness": 45.599999999999994
//                    },
//                    {
//                        "gamma": 1
//                    }
//                ]
//            },
//            {
//                "featureType": "road.arterial",
//                "stylers": [
//                    {
//                        "hue": "#FF0300"
//                    },
//                    {
//                        "saturation": -100
//                    },
//                    {
//                        "lightness": 51.19999999999999
//                    },
//                    {
//                        "gamma": 1
//                    }
//                ]
//            },
//            {
//                "featureType": "road.local",
//                "stylers": [
//                    {
//                        "hue": "#FF0300"
//                    },
//                    {
//                        "saturation": -100
//                    },
//                    {
//                        "lightness": 52
//                    },
//                    {
//                        "gamma": 1
//                    }
//                ]
//            },
//            {
//                "featureType": "water",
//                "stylers": [
//                    {
//                        "hue": "#0078FF"
//                    },
//                    {
//                        "saturation": -13.200000000000003
//                    },
//                    {
//                        "lightness": 2.4000000000000057
//                    },
//                    {
//                        "gamma": 1
//                    }
//                ]
//            },
//            {
//                "featureType": "poi",
//                "stylers": [
//                    {
//                        "hue": "#00FF6A"
//                    },
//                    {
//                        "saturation": -1.0989010989011234
//                    },
//                    {
//                        "lightness": 11.200000000000017
//                    },
//                    {
//                        "gamma": 1
//                    }
//                ]
//            }
//        ];
//        // lat lng marker
//TODO AGGIUNGERE REPLACE
//        const markerLatArray = singleMap.getAttribute("data-marker-lat").split(";");
//        const markerLngArray = singleMap.getAttribute("data-marker-lng").split(";");
//        // create empty LatLngBounds object to center map automatically between markers
//        let bounds = new google.maps.LatLngBounds();
//        if (markerLatArray && markerLngArray) {
//            const map = new google.maps.Map(singleMap, {
//                zoom: 11,
//                disableDefaultUI: true,
//                styles: styleMap
//            });
//            const iconDefault = "/assets/icons/Marker.svg";
//            if (markerLatArray && markerLngArray && markerLatArray.length > 0 && markerLngArray.length > 0) {
//                for (let i = 0; i < markerLatArray.length && i < markerLngArray.length; i++) {
//                    let markerLat = parseFloat(markerLatArray[i]);
//                    let markerLng = parseFloat(markerLngArray[i]);
//                    let marker = new google.maps.Marker({
//                        position: { lat: markerLat, lng: markerLng },
//                        map: map,
//                        icon: iconDefault
//                    });
//                    bounds.extend(marker.getPosition());
//                }
//                map.fitBounds(bounds);
//            }
//        }
//    });
//};
